






















































































































import {
  addfollowLogData,
  addfollowLogApi,
  getFollowStageApi,
} from "@/api/studentFollow";
import imageUploader from "@/components/imageUploader.vue";
import { Vue, Prop, Component } from "vue-property-decorator";
@Component({
  name: "logFollowDialog",
  components: {
    imageUploader,
  },
})
export default class extends Vue {
  @Prop() logData!: any;
  @Prop() modeList!: any[];
  // @Prop() stageList!: any[];
  @Prop() lantentList!: any[];
  followLatent: any[] = [];
  followModeList: any[] = [];
  followStageList: any[] = [];
  form: any = {
    student_id: "",
    student_follow_id: "",
    mode: "",
    stage: "",
    intent: "",
    content: "",
    follow_content: "",
    pre_follow_time: "",
    images: [],
  };
  uploadList: any[] = [];
  rules = {
    mode: [{ required: true, message: "请选择跟进方式", trigger: "change" }],
    stage: [{ required: true, message: "请选择跟进阶段", trigger: "change" }],
    intent: [{ required: true, message: "请选择用户意向", trigger: "change" }],
  };
  dialogVisible: boolean = false;
  followDateOption = {
    disabledDate: (date: any) => {
      return date.getTime() < Date.now() - 1 * 24 * 3600 * 1000;
    },
  };
  openDialog() {
    this.followLatent = this.lantentList;
    this.followModeList = this.modeList;
    // this.followStageList = this.stageList;
    // 跟进阶段会随学员类型改动，需要即时获取
    getFollowStageApi({ student_id: this.logData.student.student_id }).then(
      (res: any) => {
        this.followStageList = res.data.list;
      }
    );
    this.form = {
      student_id: this.logData.student.student_id,
      student_follow_id: this.logData.id,
      mode: "",
      stage: "",
      intent: "",
      content: "",
      follow_content: "",
      pre_follow_time: "",
      images: [],
    };
    this.dialogVisible = true;
  }
  closeDialog() {
    this.dialogVisible = false;
  }
  uploadImageFinish(data: any) {
    this.uploadList.push(data);
  }
  deleteImage(i: number) {
    const copy = [...this.uploadList];
    copy.splice(i, 1);
    this.uploadList = copy;
  }
  handleSubmit() {
    (this.$refs["mainForm"] as Vue & { validate: Function }).validate(
      (valid: boolean) => {
        if (valid) {
          const params = { ...this.form };
          if (params.pre_follow_time <= new Date().getTime()) {
            this.$message({
              type: "warning",
              message: "跟进时间不能早于当前时间",
            });
            return false;
          }
          if (params.pre_follow_time) {
            params.pre_follow_time = Math.floor(params.pre_follow_time / 1000);
          } else {
            delete params.pre_follow_time;
          }
          if (this.uploadList.length > 0) {
            const arr: any[] = [];
            this.uploadList.map((item: any) => {
              arr.push(item.name);
            });
            params.images = arr;
          }
          addfollowLogApi(params).then(() => {
            this.$message({
              type: "success",
              message: "新增成功",
            });
            this.$emit("change");
            this.closeDialog();
          });
        }
      }
    );
  }
}
